import { openobserveLogs } from "@openobserve/browser-logs";
import config from "./config";
export function initLogs() {
  openobserveLogs.init({
    clientToken: config.clientToken,
    site: config.site,
    organizationIdentifier: config.organizationIdentifier,
    service: config.service,
    env: config.env,
    version: config.version,
    apiVersion: config.apiVersion,
    forwardErrorsToLogs: true,
    insecureHTTP: false,
  });
}
